<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../gtm";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let disabled = null;
	export let pageTitle = null;
	export let lastVisitedPage = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;

	const handleSubmit = (e) => {
		buttons.blockNext();
		e.preventDefault();

		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey3, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/gverify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						await registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}

					grecaptcha.render(document.getElementById("g-recaptcha"), {
						sitekey: projectSettings.gSiteKey2,
						callback: reCaptchaV2
					});
				}

				return false;
			});
		});
	};

	const reCaptchaV2 = async (token) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify({ token: token })
		};

		let url = "/api/gverifyv2";
		let response = await fetch(`${url}`, options);
		let data = await response.json();

		if (data.status) {
			await registerFormStart();

			buttons.next();
			buttons.unblock();
		}
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Register for the {projectSettings.classActionName}</h1>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					James Hardie Industries plc (James Hardie) is an Irish-domiciled company, traded on the New York Stock Exchange (NYSE) and Australian Securities Exchange (ASX).
				</p>
				<p>
					Shine Lawyers is investigating a potential class action against James Hardie. You are eligible to register for the investigation if you acquired an interest in James Hardie securities between 21 May 2025 and 19 August 2025.
				</p>
				<p>
					You are encouraged to register your interest in this potential class action against James Hardie by clicking on the 'Register for the investigation' button below.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn cols="12">
					<!-- svelte-ignore a11y-label-has-associated-control -->
					<label class="mb-3">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</label>
				</FormColumn>
				<FormColumn cols="12">
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.PrivacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"></Checkbox>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center" cols="12">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER FOR THE INVESTIGATION"
					disableNext={!$model.PrivacyPolicyConfirmed}></NavigationButtons>
			</FormColumn>
			<FormColumn cols="12">
				<div class="recaptcha">
					<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you require support completing your registration, please contact Shine Lawyers on
					<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
					<ClassActionEmailAddress></ClassActionEmailAddress>.
				</p>
				<p class="data-retention">
					As you complete this form, the information that you provide will be stored securely in our database.
					If you choose to leave this form at any stage during this process, it will cancel your registration.
					Data provided up until the last page change will be held for 7 days to assist with recovery should
					you have encountered an error or wish to proceed, following this time all draft data will be
					permanently deleted.
				</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.data-retention {
		font-size: 0.8rem;
		font-style: italic;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
